import React from 'react';

import {Box, IconButton, Typography } from '@mui/material';
import {Edit} from '@mui/icons-material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';


export const CxCodeList = ({ items, enableEdit, onEditChange, enableOrder, onOrderChange,
                             showRef, showQuantity, showPump, showWarranty, showMaterialList, showClearingList }) => {

    const handleOrderChange = (itemKey, direction) => {
        const newItems = [...items];
        const index = newItems.findIndex(item => item.key === itemKey);
        if (index === -1) return;

        if (direction === 'up' && index > 0) {
            // Swap with the previous item
            [newItems[index], newItems[index - 1]] = [newItems[index - 1], newItems[index]];
        } else if (direction === 'down' && index < newItems.length - 1) {
            // Swap with the next item
            [newItems[index], newItems[index + 1]] = [newItems[index + 1], newItems[index]];
        }

        // Update the order attribute based on the new index
        newItems.forEach((item, idx) => {
            item.order = idx;
        });

        onOrderChange(newItems); // Trigger the order change callback
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {items.map((item) => (
                <Box
                    key={item.key}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: 1,
                        border: '1px solid #ccc',
                        borderRadius: 1,
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 1 }}>
                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                            {item.ref ? `${item.value} (${item.ref})` : item.value}
                        </Typography>

                        <Typography variant="body2" sx={{ color: item.active ? 'green' : 'red' }}>
                            {item.active ? 'aktiv' : 'inaktiv'}
                        </Typography>

                        {showRef          &&  <Typography variant="body2">SORBA Nr: {item.ref ? item.ref : 'Keine'}</Typography>}
                        {showQuantity     &&  <Typography variant="body2">Anzahl: {item.quantity}</Typography>}
                        {showWarranty     && (<Typography variant="body2">Garantie: {item.warranty ? 'Ja' : 'Nein'}</Typography>)}
                        {showPump         && (<Typography variant="body2">Pumpe: {item.pump ? 'Ja' : 'Nein'}</Typography>)}
                        {showMaterialList && (<Typography variant="body2">Bestelliste: {item.material_list ? 'Ja' : 'Nein'}</Typography>)}
                        {showClearingList && (<Typography variant="body2">Abräumliste: {item.clearing_list ? 'Ja' : 'Nein'}</Typography>)}

                        <Typography variant="body2" sx={{ color: 'text.secondary'}}>
                            (key={item.key}, order={item.order})
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'inline-flex', gap: 1, mr: 1 }}>
                        {enableOrder &&
                            <>
                                <IconButton
                                    disabled={item.order === 0}
                                    color="primary"
                                    onClick={() => handleOrderChange(item.key, 'up')}>
                                    <ArrowUpwardIcon />
                                </IconButton>

                                <IconButton
                                    disabled={item.order === items.length - 1}
                                    color="primary"
                                    onClick={() => handleOrderChange(item.key, 'down')}>
                                    <ArrowDownwardIcon />
                                </IconButton>
                            </>
                        }

                        { enableEdit &&
                            <IconButton
                                color="primary"
                                onClick={() => onEditChange(item)}>
                                <Edit />
                            </IconButton>
                        }
                    </Box>
                </Box>
            ))}
        </Box>
    );
};
